import React, { useState, useEffect } from 'react';
import { PageComponentProps } from 'shared/interface/globalInterface';
import CommissionDetailsPage from '../../pages/CommissionDetailsPage/CommissionDetailsPage';
import { fetchProductsData, fetchSingleCommissionDetails, updateCommissionDetails } from '../../api';
import { FormModel, Product } from 'modules/commission_terms/pages/CommissionDetailsPage/CommissionDetailsPage.types';
import { COMMISSION_TYPE, FIELDS } from '../../fields/types';
import { mapApiDataForView, mapFormDataForUpdate } from 'modules/commission_terms/mapper';
import { commissionTerms } from 'routes/routePaths';
import { CommissionTermsGetResponse } from 'modules/commission_terms/api/types';
import ValidationErrorModal from '../../components/ValidationErrorModal/ValidationErrorModal';

type Props = PageComponentProps;

const Index: React.FC<Props> = ({ match, history }) => {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [products, setProducts] = useState<Product[]>([]);
  const [formData, setFormData] = useState<Omit<FormModel, 'filters'>>({
    [FIELDS.COMMISSION_TERM_TYPE]: COMMISSION_TYPE.ONGOING,
    [FIELDS.COMMISSION_NAME]: '',
    [FIELDS.FEE]: null,
    [FIELDS.UPFRONT_FEE]: null,
    [FIELDS.ONGOING_FEE]: null,
    [FIELDS.FEE_END_DATE]: '',
    [FIELDS.PRODUCTS]: [],
  });
  const { id } = match.params;
  const [saveData, setSaveData] = useState<FormModel>();
  const [saveErrors, setSaveErrors] = useState(null);

  useEffect(() => {
    const fetchProducts = (): Promise<Product[]> =>
      new Promise((resolve) => fetchProductsData().then(({ data }) => resolve(data)));

    const fetchCommissionData = (): Promise<CommissionTermsGetResponse> =>
      new Promise((resolve) => fetchSingleCommissionDetails(id).then(({ data }) => resolve(data)));

    Promise.all([fetchCommissionData(), fetchProducts()]).then(([commissionData, products]) => {
      const filteredProducts = products.filter((product) => commissionData.products.includes(product.code));
      setFormData(mapApiDataForView({ ...commissionData, products: filteredProducts }));
      setProducts(products);
      setIsLoading(false);
    });
  }, [id]);

  const onSubmit = async (data: FormModel, force = false) => {
    setSaveData(data);
    try {
      await updateCommissionDetails(id, mapFormDataForUpdate(data), force);
      setSaveErrors(null);
      history.push(commissionTerms.index);
    } catch (err) {
      console.error(err);
      setSaveErrors(err);
    }
  };

  return (
    <>
      {formData && !isLoading && (
        <>
          <CommissionDetailsPage
            formData={formData}
            onSubmit={(data: FormModel) => onSubmit(data)}
            availableProducts={products}
            isEdited={true}
          />
          <ValidationErrorModal
            error={saveErrors}
            onUpdateAnyway={() => onSubmit(saveData as FormModel, true)}
            onCloseButtonClick={() => setSaveErrors(null)}
          />
        </>
      )}
    </>
  );
};

export default Index;
